export default __webpack_public_path__ + "static/media/avatar.038fedd5.JPG";